const bn128 = require('./lib/index.asm.js')

module.exports = bn128